// extracted by mini-css-extract-plugin
export var container = "bh_b";
export var device = "bh_d8";
export var deviceContainer = "bh_d7";
export var icon = "bh_bw";
export var icons = "bh_bt";
export var image = "bh_k";
export var logo = "bh_bn";
export var model = "bh_d9";
export var section = "bh_j";